import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import {encryptData} from "../utils/helpFunction";
import {
    rentLanguageOptions,
    transferListLanguageOptions,
} from "./dropdown/dropdown-data";

const Rent = () => {
    const [selectedAccount, setSelectedAccount] = useState("");
    const [accountList, setAccountList] = useState([]);

    const [confirmMessage, setConfirmMessage] = useState("notLoaded");
    const [successMessage, setSuccessMessage] = useState("notLoaded");
    const [jwt, setJwt] = useState();
    const [userName, setUserName] = useState("");

    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [closeLoading, setCloseLoading] = useState(false);
    const [title, setTitle] = useState();
    const [warning] = useState("");
    const [onConfirm, setOnConfirm] = useState("");
    const [transferRequest, setTransferRequest] = useState("");
    const [, setExtractedUrl] = useState("");
    const [selectedPeriods, setSelectedPeriods] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState(null);

    const [tenantId, setTenantId] = useState("");
    const [paymentList, setPaymentList] = useState([]);
    const [error] = useState(null);

    const [tenant, setTenant] = useState("");
    const [checkedItems, setCheckedItems] = useState([]);

    const [isFirst, setIsFirst] = useState(true);

    const isFormValid = () => {
        if (!selectedAccount) return false;
        return (!(!tenantId ||
            tenantId.length < 6 ||
            !tenantId.match("^[a-zA-Z]{4,5}\\-\\d+$")));
    };

    const handleSearch = () => {

        sendDataToAndroid("searchByTenantId");
    };

    const completePayment = () => {
        if (selectedPeriods) {
            const message =
                selectedPeriods
                    .map(
                        (p, i) =>
                            `<b>${i + 1}.</b> ${p.tenantName} — ${p.paymentType} (${p.reason})<br>` +
                            `<small>${p.buildingName} / ${p.roomName} — <b>${p.totalAmount.toLocaleString()}</b></small><br><br>`
                    )
                    .join("") +
                `<hr><b>Total to Pay:</b> ${selectedPeriods
                    .reduce((sum, p) => sum + p.totalAmount, 0)
                    .toLocaleString()}`;

            setTransferRequest({
                collectionType: "BANK",
                tenant: tenant,
                channel: "OMNI",
                createdBy: userName,
                branchCode: "MAIN",
                branchName: "Main Branch",
                pnr: `PNR${Date.now()}`,
                accountHolder: userName,
                accountNumber: selectedAccount,
                payments: selectedPeriods.map(item => ({
                    paymentType: item.paymentType,
                    variableAmount: item.totalAmount,
                    note: `Payment for ${item.description}`,
                    reason: item.reason,
                    period: item.period,
                    amenityId: item.amenityId,
                    leaseId: item.leaseId,
                }))
            });

            setConfirmMessage(message);
        } else {
            setErrorMessage("Please select at least one payment");

        }
    };

    const handleFirstRender = (request) => {
        if (!isFirst) {
            sendDataToAndroid(request);
        }
        setIsFirst(false);
    };

    useEffect(() => {
        sendDataToAndroid("first");

        window.receiveDataFromAndroid = (data) => {
            var dataString = JSON.stringify(data);
            var obj = JSON.parse(dataString);

            if (JSON.parse(obj.request).name === "accountList") {
                if (
                    obj.response !== undefined &&
                    JSON.parse(obj.response).data !== undefined
                ) {
                    let uniqueAccountList = [];
                    JSON.parse(JSON.parse(obj.response).data).forEach((account) => {
                        uniqueAccountList = [
                            ...uniqueAccountList,
                            {label: account.accounts, value: account.accounts},
                        ];
                        setAccountList([...uniqueAccountList]);
                    });
                }
            }

            if (JSON.parse(obj.request).name === "confirmResponse") {
                setOnConfirm("true");
            }

            if (JSON.parse(obj.request).name === "jwt") {
                setJwt(JSON.parse(obj.response).data);
            }

            if (JSON.parse(obj.request).name === "response") {
                const urlFromResponse = JSON.parse(obj.request).url;
                setExtractedUrl(urlFromResponse);
                handleDataBasedOnUrl(urlFromResponse, JSON.parse(obj.response).data);
            }

            if (JSON.parse(obj.request).name === "userName") {
                setUserName(JSON.parse(obj.response).data);
            }
        };
    }, []);

    const handleDataBasedOnUrl = (url, responseData) => {
        console.log("method called " + url);
        if (url.includes("rentApp/services/findByTenantId")) {
            const {data, status, desc} = JSON.parse(responseData);
            console.log(JSON.stringify(data));
            if (status === true) {
                setPaymentList(data.items);
            } else {
                setErrorMessage(desc);
                setSuccessMessage("");
            }
        } else if (url.includes("rentApp/services/payRentFee")) {
            const {data, status, desc} = JSON.parse(responseData);
            console.log(JSON.stringify(data));
            if (status === true) {
                setSuccessMessage(
                    `Payments completed: ` +
                    data.items
                        .map(
                            (p) =>
                                `${p.tenantName} (${p.reason}) - ${p.amount} to ${p.buildingName} [PNR: ${p.pnr}, Ref: ${p.transactionId}]`
                        )
                        .join("; ") +
                    "."
                );

            } else {
                setErrorMessage(desc);
                setSuccessMessage("");
            }
        }
    };

    const handleCheckboxChange = (index) => {
        const updatedCheckedItems = [...checkedItems];


        updatedCheckedItems[index] = !updatedCheckedItems[index];

        setCheckedItems(updatedCheckedItems);

        const newSelectedPeriods = paymentList.filter(
            (period, i) => updatedCheckedItems[i]
        );

        setSelectedPeriods(newSelectedPeriods);

    };


    function capitalizeFirstLetter(string) {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const handleAccountChange = (e) => {
        setSelectedAccount(e.target.value);
        setPaymentList(null);
    };

    const handleTenantIdChange = (e) => {
        setTenantId(e.target.value.trim().toUpperCase());
        const localTenant = e.target.value.trim().toLowerCase().split("-")[0]
        console.log(localTenant);
        setTenant(localTenant);
    };

    useEffect(() => {
        setPaymentList(null);
    }, [tenantId, tenant]);

    useEffect(() => {
        if (!isFirst) {
            setTitle(transferListLanguageOptions[jwt][9]);
        }
        setIsFirst(false);
    }, [jwt]);
    useEffect(() => {
        handleFirstRender("title");
    }, [title]);

    useEffect(() => {
        handleFirstRender("confirm");
    }, [confirmMessage]);
    useEffect(() => {
        handleFirstRender("success");
    }, [successMessage]);

    useEffect(() => {
        handleFirstRender("warning");
    }, [errorMessage]);

    useEffect(() => {
        handleFirstRender("openLoading");
    }, [loading]);

    useEffect(() => {
        handleFirstRender("openLoading");
        if (closeLoading) {
            setLoading(false);
            setCloseLoading(false);
        }
    }, [closeLoading]);

    useEffect(() => {
        handleFirstRender("warning");
    }, [warning]);

    useEffect(() => {
        if (onConfirm !== "") {
            handleFirstRender("request");
        }
    }, [onConfirm]);

    useEffect(() => {
        sendDataToAndroid("school");
    }, []);

    const sendDataToAndroid = (name) => {
        var transferData = {
            transferData: [],
        };
        if (name === "return") {
            transferData = {
                transferData: [
                    {
                        type: "return",
                        request: {name: "graphData"},
                        response: {},
                        name: "",
                    },
                ],
            };
        } else if (name === "title") {
            transferData = {
                transferData: [
                    {
                        type: "title",
                        request: {name: "title"},
                        response: {data: title},
                        name: "",
                    },
                ],
            };
        } else if (name === "first") {
            transferData = {
                transferData: [
                    {
                        type: "first",
                        request: {name: "first"},
                        response: {},
                        name: "",
                    },
                ],
            };
        } else if (name === "confirm") {
            transferData = {
                transferData: [
                    {
                        type: "confirm",
                        request: {name: "confirm"},
                        response: {data: confirmMessage},
                        name: "",
                    },
                ],
            };
        } else if (name === "openLoading") {
            transferData = {
                transferData: [
                    {
                        type: "openLoading",
                        request: {name: "openLoading"},
                        response: {data: loading},
                        name: "",
                    },
                ],
            };
        } else if (name === "closeLoading") {
            transferData = {
                transferData: [
                    {
                        type: "closeLoading",
                        request: {name: "closeLoading"},
                        response: {data: closeLoading},
                        name: "",
                    },
                ],
            };
        } else if (name === "warning") {
            transferData = {
                transferData: [
                    {
                        type: "warning",
                        request: {name: "warning"},
                        response: {data: errorMessage},
                        name: "",
                    },
                ],
            };
        } else if (name === "error") {
            transferData = {
                transferData: [
                    {
                        type: "error",
                        request: {name: "error"},
                        response: {data: errorMessage},
                        name: "",
                    },
                ],
            };
        } else if (name === "success") {
            transferData = {
                transferData: [
                    {
                        type: "success",
                        request: {name: "success"},
                        response: {data: successMessage},
                        name: "",
                    },
                ],
            };
        } else if (name === "searchByTenantId") {
            console.log("Data sent to fetch school");
            transferData = {
                transferData: [
                    {
                        type: "requestPost",
                        request: {name: "rentApp/services/findByTenantId"},
                        response: {
                            data: {
                                tenantId: tenantId,
                                tenant: tenant,
                                hashedValue: "hashedValue",
                            },
                        },
                        name: "",
                    },
                ],
            };
        } else if (name === "request") {
            transferData = {
                transferData: [
                    {
                        type: "requestPost",
                        request: {
                            name: "rentApp/services/payRentFee",
                        },
                        response: {
                            data: {
                                encryptedString: encryptData(JSON.stringify(transferRequest)),
                            },
                        },
                        name: "",
                    },
                ],
            };
        }
        sendToAndroid(transferData);
        setConfirmMessage("");
        setOnConfirm("");
        setErrorMessage("");
    };

    const FeeDetailsViewer = ({payment}) => (
        <div className="mt-2 ml-6 p-3 border-l-2 border-indigo-300 bg-indigo-50 text-sm text-gray-700">
            <p>
                {rentLanguageOptions[jwt]?.labels[4]}: {payment.totalAmount.toFixed(2)}
            </p>
            <p>
                {rentLanguageOptions[jwt]?.labels[5]}: {payment.dueDate}
            </p>
            <p>
                {rentLanguageOptions[jwt]?.labels[6]}: {payment.tenantName} ({payment.buildingName} / {payment.roomName})
            </p>
            <p>
                {rentLanguageOptions[jwt]?.labels[7]}: {payment.feeCalculationType}
            </p>
            <p>
                {rentLanguageOptions[jwt]?.labels[8]}: {payment.reason}
            </p>
        </div>
    );
    // New state to manage the expanded item index

    const toggleDetails = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        // <ComingSoon/>
        <div className="service-screen w-full max-w-md mx-auto p-4">
            <div className="border border-gray-300 rounded-xl shadow-lg p-6 bg-white">
                <div className="mb-4">
                    <label className="block mb-1 font-medium text-gray-700">
                        {rentLanguageOptions[jwt]?.labels[0]}
                    </label>
                    <select
                        value={selectedAccount}
                        onChange={handleAccountChange}
                        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                        <option key={0} value={"choose"}>
                            {rentLanguageOptions[jwt]?.labels[0]}
                        </option>
                        {accountList.map((s) => (
                            <option key={s.id} value={s.value}>
                                {s.value}
                            </option>
                        ))}
                    </select>
                </div>
                <>
                    <div className="mb-4">
                        <label className="block mb-1 font-medium text-gray-700">
                            {rentLanguageOptions[jwt]?.labels[1]}
                        </label>
                        <input
                            type="text"
                            pattern={"^[A-Z,a-z]{4,5}[0-9]+$"}
                            value={tenantId}
                            onChange={handleTenantIdChange}
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                            placeholder={rentLanguageOptions[jwt]?.labels[1]}
                        />
                    </div>
                </>
                <button
                    onClick={handleSearch}
                    disabled={!isFormValid()}
                    className={`w-full py-2 rounded text-white font-semibold transition ${
                        isFormValid()
                            ? "bg-blue-600 hover:bg-blue-700"
                            : "bg-gray-400 cursor-not-allowed"
                    }`}
                >
                    {rentLanguageOptions[jwt]?.labels[2]}
                </button>

                {loading && (
                    <p className="text-blue-500 mt-4">
                        {rentLanguageOptions[jwt]?.labels[3]}
                    </p>
                )}
                {error && <p className="text-red-500 mt-4">{error}</p>}

                <div className=" border-t pt-4">

                    <div className="mt-6 border-t pt-4">
                        {paymentList && (
                            <div>
                                <h2 className="text-lg font-semibold text-gray-700 mt-2">
                                    {rentLanguageOptions[jwt]?.labels[4]}
                                </h2>
                                <div className="bg-gray-100 mt-2 p-4 rounded">
                                    <div>
                                        {paymentList.map((payment, index) => (
                                            <div key={payment.id} className="mb-3 border-b pb-2">
                                                <label
                                                    className="flex items-center justify-between gap-2 text-gray-800 cursor-pointer"
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <input
                                                            type="checkbox"
                                                            name="period"
                                                            checked={checkedItems[index]}
                                                            onChange={() => handleCheckboxChange(index)}
                                                            className={`h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500`}
                                                        />
                                                        {/* Display primary fields inline */}
                                                        <span className="font-medium">
                                {capitalizeFirstLetter(payment.paymentType.toLowerCase())}
                            </span>
                                                        <span className="text-lg font-bold text-indigo-700">
                                {payment.totalAmount.toFixed(2)} Br
                            </span>
                                                    </div>

                                                    {/* Expand/Collapse Button */}
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault(); // Prevent form submission if in a form
                                                            toggleDetails(index);
                                                        }}
                                                        className="text-indigo-500 hover:text-indigo-700 text-sm"
                                                    >
                                                        {expandedIndex === index ? "Hide Details ▲" : "Show Details ▼"}
                                                    </button>

                                                </label>

                                                {expandedIndex === index && <FeeDetailsViewer payment={payment}/>}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <button
                                    onClick={completePayment}
                                    disabled={!selectedAccount || !paymentList || selectedPeriods.length < 1}
                                    className={`w-full py-2 rounded text-white font-semibold transition ${
                                        selectedPeriods.length > 0
                                            ? "bg-green-600 hover:bg-green-600"
                                            : "bg-gray-400 cursor-not-allowed"
                                    }`}>
                                    {rentLanguageOptions[jwt]?.labels[3]}
                                </button>
                                <div/>

                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
};
export default Rent;
